import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ className = "", style = {}, textStyle = {} }) => {
    const navigate = useNavigate();

    return (
        <div
            className={`logo ${className}`}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", ...style }}
            onClick={() => navigate("/")}
        >
            <img 
                src="/logo_new.svg" 
                alt="Routechef Logo" 
                style={{ height: "35px", marginRight: "0.5rem" }} 
            />
            <span style={{ display: 'flex', alignItems: 'center', ...textStyle }}>
                <span style={{ 
                    color: "#FF5B15", 
                    fontWeight: "600", 
                    fontSize: "28px", 
                    fontFamily: "'Outfit', sans-serif" 
                }}>
                    Route
                </span>
                <span style={{ 
                    color: "#0A0A0A", 
                    fontSize: "28px", 
                    fontWeight: "400", 
                    fontFamily: "'Outfit', sans-serif" 
                }}>
                    chef
                </span>
            </span>
        </div>
    );
};

export default Logo;
